











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class NumberInput extends Vue {
  @Prop({required: true, default: 1}) public value!: number;
  public number: number = 0;

  public onChange() {
    if (this.number < 0) {
      this.number = 0;
    }
    this.$emit('input', this.number);
  }

  public handleInput(event: any) {
    if (event.key === 'e' || event.key === '+' || event.key === '-') {
      event.preventDefault();
    }
    if (this.number > 99) {
      this.number = 99;
    }
    if (this.number < 0) {
      this.number = 0;
    }
  }

  public increase() {
    this.number++;
    this.$emit('input', this.number);
  }

  public decrease() {
    if (this.number > 0) {
      this.number--;
      this.$emit('input', this.number);
    }
  }

  @Watch('value', {immediate: true})
  public fetchValue(value: number) {
    this.number = value;
  }
}
